/**
 * Maps each ACF layout (choose_a_section) to the fields that belong on that row.
 * ACF stores all layout fields on every row; each choose_a_section renders one block only
 * (its own field), ignoring stale data copied onto other layouts.
 */

export const OPSI_SECTION_FIELDS = {
  FullWidthText: ["fullwidthtext"],
  SplitParagraphText: ["split_paragraph_text"],
  // StatCard layout in CMS only has label / figure / body / circlecolor — not fullwidthtext
  StatCard: ["statcard"],
  Image: ["image"],
  SmallImage: ["small_image"],
  IconBoxImage: ["icon_box_image"],
  Accordion: ["accordion"],
  HeaderWithArrows: ["header_with_arrows"],
  BoxSliderSection: ["box_slider_section"],
  LargeBoxSliderSection: ["large_box_slider_section"],
  URLLinks: ["url_links"],
  AppendixTable: ["appendix_table"],
};

/** Field keys used by the section renderer (order = render order). */
export const OPSI_FIELD_KEYS = [
  "fullwidthtext",
  "statcard",
  "split_paragraph_text",
  "header_with_arrows",
  "image",
  "small_image",
  "icon_box_image",
  "box_slider_section",
  "large_box_slider_section",
  "accordion",
  "url_links",
  "appendix_table",
];

export const getOpsiSectionFieldKeys = (sectionType) => {
  const key = String(sectionType || "").trim();
  return OPSI_SECTION_FIELDS[key] || [];
};
